import { render, staticRenderFns } from "./Octicon.vue?vue&type=template&id=5433d50d&"
import script from "./Octicon.vue?vue&type=script&lang=js&"
export * from "./Octicon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports